const INITIAL_EQUIPMENT_STATE_ = {
  Vehicles: [],
  Chargers: [],
};

export default INITIAL_EQUIPMENT_STATE_;
